// Clarity Lens Co - Premium Eyewear & Vision Accessories
// Editorial magazine-style ecommerce with warm stone & ink palette

// ============================================
// SITE IMAGES - Editorial Lifestyle Photography
// ============================================
export const siteImages = {
  // Hero images - editorial portraits, soft natural light
  heroMain: 'https://images.pexels.com/photos/26459441/pexels-photo-26459441.jpeg',
  heroSecondary: 'https://images.unsplash.com/photo-1644557517018-dcfc98e37e40?w=1600&q=80',
  heroLifestyle: 'https://images.unsplash.com/photo-1611050571146-9719dfbb13d1?w=1600&q=80',

  // Product showcase images
  productShowcase1: 'https://images.unsplash.com/photo-1603578119639-798b8413d8d7?w=1400&q=80',
  productShowcase2: 'https://images.unsplash.com/photo-1619016708406-7c9a4f676f2d?w=1400&q=80',
  productShowcase3: 'https://images.unsplash.com/photo-1608906709312-fe17f7c1a5a6?w=1400&q=80',

  // Section backgrounds
  ctaBackground: 'https://images.pexels.com/photos/33658724/pexels-photo-33658724.jpeg',
  featuredBackground: 'https://images.unsplash.com/photo-1616657025576-ddbfc04c2b20?w=1600&q=80',
  lifestyleEditorial: 'https://images.unsplash.com/photo-1611050571146-9719dfbb13d1?w=1600&q=80',

  // Page banners - each page has its own unique banner
  shopBanner: 'https://images.unsplash.com/photo-1619016708406-7c9a4f676f2d?w=1800&q=80',
  aboutBanner: 'https://images.pexels.com/photos/33658724/pexels-photo-33658724.jpeg',
  contactBanner: 'https://images.unsplash.com/photo-1616657025576-ddbfc04c2b20?w=1800&q=80',
  returnsBanner: 'https://images.unsplash.com/photo-1608906709312-fe17f7c1a5a6?w=1800&q=80',
  privacyBanner: 'https://images.unsplash.com/photo-1603578119639-798b8413d8d7?w=1800&q=80',
  categoryBanner: 'https://images.unsplash.com/photo-1644557517018-dcfc98e37e40?w=1800&q=80',
};

// ============================================
// PRODUCT IMAGES - Provided product photos
// ============================================
const productImages = {
  clearVision: 'https://i.ebayimg.com/images/g/c2wAAOSwxvJnMnot/s-l400.jpg',
  uvShield: 'https://customer-assets.emergentagent.com/job_d7e39ef4-7577-43d2-8708-cf710b0bb0aa/artifacts/znt21cxa_image.png',
  screenGuard: 'https://m.media-amazon.com/images/I/61oohbntLpL.jpg',
  focusPlus: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSv2_psFDrOOQAQsLILVFcU1bzmnAkVJQ5lMw&s',
  activePro: 'https://activeyewear.com/cdn/shop/products/IMG_8683_600x.jpg?v=1625010175',
  eliteStyle: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQmNojFKuVqvKwmV6Dvuhk_4dr0xiBTckZ4xQ&s',
  snapShade: 'https://p19-oec-general-useast5.ttcdn-us.com/tos-useast5-i-omjb5zjo8w-tx/b0c7e7d433064495a61dce402a266255~tplv-fhlh96nyum-resize-webp:800:800.webp?dr=12190&t=555f072d&ps=933b5bde&shp=8dbd94bf&shcp=948674b7&idc=useast5&from=2378011839',
  proClean: 'https://s10proclean.com/cdn/shop/products/S10-Pro-Clean-aluminum-aluminum-clear_1200x1200.jpg?v=1597357431',
  // Premium / luxury / bundle imagery
  titanElite: 'https://images.pexels.com/photos/10837794/pexels-photo-10837794.jpeg',
  heritageGold: 'https://images.pexels.com/photos/36846560/pexels-photo-36846560.jpeg',
  platinumSignature: 'https://images.pexels.com/photos/29488632/pexels-photo-29488632.jpeg',
  executiveBundle: 'https://images.pexels.com/photos/26050120/pexels-photo-26050120.jpeg',
  familySet: 'https://images.pexels.com/photos/27624600/pexels-photo-27624600.jpeg',
  wardrobeSet: 'https://images.pexels.com/photos/29560423/pexels-photo-29560423.jpeg',
};

const categoryImages = {
  prescription: productImages.clearVision,
  sunglasses: productImages.uvShield,
  blueLight: productImages.screenGuard,
  reading: productImages.focusPlus,
  sports: productImages.activePro,
  designer: productImages.eliteStyle,
  clipOn: productImages.snapShade,
  accessories: productImages.proClean,
};

export const SHIPPING_NOTICE = 'We ship within the USA via USPS';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '3-5 business days';
export const FREE_SHIPPING_THRESHOLD = 75;

// Card Statement Descriptor
export const CARD_DESCRIPTOR = 'CLARITY LENS CO';

// Contact Info - Clarity Lens Co
export const CONTACT_INFO = {
  phone: '(844) 480-1227',
  email: 'support@claritylensco.com',
  corpName: 'LP Capital Holdings LLC',
  address: {
    street: '1634 TARA CT',
    city: 'LANCASTER',
    state: 'CA',
    zip: '93535',
    country: 'United States'
  }
};

// Return Address (unchanged)
export const RETURN_ADDRESS = {
  street: '555 Remington Blvd., Ste B',
  city: 'Bolingbrook',
  state: 'IL',
  zip: '60440',
  country: 'USA'
};

// ============================================
// CATEGORIES - Eyewear & Vision Accessories (UNCHANGED)
// ============================================
export const categories = [
  {
    id: 'prescription-glasses',
    name: 'Prescription Glasses',
    slug: 'prescription-glasses',
    description: 'Modern frames built to be paired with your prescription',
    image: categoryImages.prescription,
    productCount: 1
  },
  {
    id: 'sunglasses',
    name: 'Sunglasses',
    slug: 'sunglasses',
    description: 'Stylish polarized UV protection for sunny days',
    image: categoryImages.sunglasses,
    productCount: 1
  },
  {
    id: 'blue-light-glasses',
    name: 'Blue Light Glasses',
    slug: 'blue-light-glasses',
    description: 'Filter blue light and reduce digital eye strain',
    image: categoryImages.blueLight,
    productCount: 1
  },
  {
    id: 'reading-glasses',
    name: 'Reading Glasses',
    slug: 'reading-glasses',
    description: 'Lightweight clarity for books, screens and detail work',
    image: categoryImages.reading,
    productCount: 1
  },
  {
    id: 'sports-eyewear',
    name: 'Sports Eyewear',
    slug: 'sports-eyewear',
    description: 'Performance eyewear engineered for movement',
    image: categoryImages.sports,
    productCount: 1
  },
  {
    id: 'designer-frames',
    name: 'Designer Frames',
    slug: 'designer-frames',
    description: 'Elevated silhouettes in premium materials',
    image: categoryImages.designer,
    productCount: 4
  },
  {
    id: 'clip-on-lenses',
    name: 'Clip-On Lenses',
    slug: 'clip-on-lenses',
    description: 'Convert any frame into sunglasses in a snap',
    image: categoryImages.clipOn,
    productCount: 1
  },
  {
    id: 'accessories',
    name: 'Accessories',
    slug: 'accessories',
    description: 'Cleaning, care and essentials for your eyewear',
    image: categoryImages.accessories,
    productCount: 1
  },
  {
    id: 'premium-collections',
    name: 'Premium Collections & Bundles',
    slug: 'premium-collections',
    description: 'Luxury frames, signature editions and curated multi-pack sets',
    image: productImages.heritageGold,
    productCount: 4
  }
];

// ============================================
// PRODUCTS - 8 Curated Eyewear & Vision Products
// ============================================
export const products = [
  {
    id: 'clearvision-classic-frame',
    name: 'ClearVision Classic Frame',
    slug: 'clearvision-classic-frame',
    sku: 'CLC-PR-001',
    price: 79.99,
    image: categoryImages.prescription,
    badge: 'Best Seller',
    categoryId: 'prescription-glasses',
    categorySlug: 'prescription-glasses',
    description: 'Lightweight prescription-ready frames designed for everyday comfort and clear vision. Crafted with a durable build and modern minimalist style, the ClearVision Classic pairs beautifully with single vision, progressive or blue light prescription lenses. Spring-loaded hinges and refined acetate detailing make these frames a quiet wardrobe staple.',
    keyBenefits: [
      'Prescription-ready in any strength',
      'Durable yet feather-light frame',
      'Modern minimalist silhouette'
    ],
    usage: 'Pair with single vision, progressive or reading prescription lenses for daily wear at work, home or on the go.',
    features: ['Prescription-Ready', 'Spring Hinges', 'Anti-Scratch Coating', 'Acetate Frame'],
    lensSpecs: {
      title: 'Lens Clarity & Prescription Details',
      intro: 'Pair these frames with our HD optical-grade prescription lenses. Each lens is precision-cut to your exact prescription, with crystal-clear clarity edge-to-edge and a premium anti-reflective finish.',
      groups: [
        {
          label: 'Lens Clarity',
          items: [
            'HD optical-grade clarity (99.9% light transmission)',
            'Anti-reflective (AR) multi-coat for sharper vision',
            'Scratch-resistant hardcoat treatment',
            'Hydrophobic & oleophobic coating (repels water, smudges, dust)',
            '100% UV400 protection built into every lens',
          ],
        },
        {
          label: 'Lens Types Supported',
          items: [
            'Single Vision (distance OR reading)',
            'Progressive / Multifocal (no-line)',
            'Bifocal (lined)',
            'Blue Light Filtering (+ optional add-on)',
            'Photochromic / Transitions (+ optional add-on)',
          ],
        },
        {
          label: 'Prescription Range (Numbers)',
          items: [
            'Sphere (SPH): −8.00 to +6.00 D',
            'Cylinder (CYL): −4.00 to +4.00 D',
            'Axis: 1° to 180°',
            'Add Power (ADD): +0.75 to +3.50 D',
            'Pupillary Distance (PD): 54 mm to 74 mm',
          ],
        },
        {
          label: 'Lens Index Options',
          items: [
            '1.50 CR-39 — standard, lightweight',
            '1.56 Mid-Index — thinner for moderate Rx',
            '1.60 High-Index — for stronger Rx (recommended above ±3.00)',
            '1.67 Ultra High-Index — thinnest profile for high Rx (±4.00 and above)',
          ],
        },
      ],
      note: 'Enter your prescription numbers at checkout, or upload a copy of your most recent prescription. Lenses are made-to-order and typically ship within 5–7 business days.',
    },
    inStock: true
  },
  {
    id: 'uvshield-polarized-sunglasses',
    name: 'UVShield Polarized Sunglasses',
    slug: 'uvshield-polarized-sunglasses',
    sku: 'CLC-SG-001',
    price: 59.99,
    image: categoryImages.sunglasses,
    badge: 'Popular',
    categoryId: 'sunglasses',
    categorySlug: 'sunglasses',
    description: 'Stylish sunglasses with full UV400 protection and polarized lenses that cut glare in bright conditions. Engineered for clarity on the road, beach or trail, the UVShield blends a timeless silhouette with a refined matte finish for unisex everyday wear.',
    keyBenefits: [
      '100% UV400 sun protection',
      'Polarized anti-glare lenses',
      'Timeless unisex silhouette'
    ],
    usage: 'Wear for driving, outdoor activities, beach days and any moment that calls for sharper vision in bright light.',
    features: ['Polarized Lenses', 'UV400 Protection', 'Matte Finish', 'Durable Frame'],
    inStock: true
  },
  {
    id: 'screenguard-blue-light-glasses',
    name: 'ScreenGuard Blue Light Glasses',
    slug: 'screenguard-blue-light-glasses',
    sku: 'CLC-BL-001',
    price: 39.99,
    image: categoryImages.blueLight,
    badge: 'Editor\u2019s Pick',
    categoryId: 'blue-light-glasses',
    categorySlug: 'blue-light-glasses',
    description: 'Designed to reduce digital eye strain and filter blue light from screens. The ScreenGuard is ideal for long workdays, gaming sessions, and late-night scrolls \u2014 helping you stay focused, sleep better, and feel more comfortable at every screen.',
    keyBenefits: [
      'Filters blue light from screens',
      'Reduces eye strain and fatigue',
      'Supports better sleep quality'
    ],
    usage: 'Wear during screen time, gaming, online meetings, or any digital device use for optimal eye comfort.',
    features: ['Anti-Blue Light Lens', 'UV400 Protection', 'Lightweight Frame', 'Scratch Resistant'],
    inStock: true
  },
  {
    id: 'focusplus-reading-glasses',
    name: 'FocusPlus Reading Glasses',
    slug: 'focusplus-reading-glasses',
    sku: 'CLC-RG-001',
    price: 29.99,
    image: categoryImages.reading,
    categoryId: 'reading-glasses',
    categorySlug: 'reading-glasses',
    description: 'Comfortable and lightweight reading glasses with enhanced clarity for books, screens, and fine detail tasks. Spring-loaded temples flex to fit, while precision optical lenses deliver crisp, distortion-free reading at any distance.',
    keyBenefits: [
      'Enhanced reading clarity',
      'Ultra-lightweight all-day wear',
      'Flexible spring hinges'
    ],
    usage: 'Use for reading books, newspapers, menus, screens, crafting and any close-up detailed task.',
    features: ['Lightweight Frame', 'Spring Hinges', 'Anti-Scratch Coating', 'Multiple Strengths'],
    lensSpecs: {
      title: 'Lens Clarity & Reading Strengths',
      intro: 'Crafted with HD optical-grade reading lenses for sharp, distortion-free vision at every close-up distance. Choose from a full range of magnification strengths below.',
      groups: [
        {
          label: 'Lens Clarity',
          items: [
            'HD optical-grade clear lenses (precision-molded CR-39)',
            'Anti-reflective (AR) coating reduces glare from lamps & screens',
            'Scratch-resistant hardcoat finish',
            'Distortion-free reading zone, edge to edge',
            '100% UV400 protection',
          ],
        },
        {
          label: 'Available Reading Strengths (Magnification / Diopter)',
          items: [
            '+1.00  (light — early reading support)',
            '+1.25',
            '+1.50  (most popular for ages 40–45)',
            '+1.75',
            '+2.00  (most popular for ages 45–50)',
            '+2.25',
            '+2.50  (most popular for ages 50–55)',
            '+2.75',
            '+3.00',
            '+3.50  (strongest — fine detail / craft work)',
          ],
        },
        {
          label: 'Frame Measurements',
          items: [
            'Lens width: 52 mm',
            'Bridge: 18 mm',
            'Temple length: 142 mm',
            'Total weight: 18 g (ultra-light)',
          ],
        },
      ],
      note: 'Not sure which strength you need? A general guide: ages 40–44 typically start at +1.00 to +1.25, ages 45–49 at +1.50 to +1.75, ages 50–54 at +2.00 to +2.25, ages 55–59 at +2.50, and ages 60+ at +2.75 and above. For an exact match, consult your optometrist.',
    },
    inStock: true
  },
  {
    id: 'activepro-performance-glasses',
    name: 'ActivePro Performance Glasses',
    slug: 'activepro-performance-glasses',
    sku: 'CLC-SP-001',
    price: 69.99,
    image: categoryImages.sports,
    badge: 'Top Rated',
    categoryId: 'sports-eyewear',
    categorySlug: 'sports-eyewear',
    description: 'Secure-fit sports eyewear built for movement, offering stability, durability and clear vision during training. Anti-slip nose pads, vented lenses and a wraparound silhouette keep the ActivePro locked in through every rep, mile and ride.',
    keyBenefits: [
      'Locked-in anti-slip fit',
      'Impact-resistant lenses',
      'Vented wraparound coverage'
    ],
    usage: 'Ideal for cycling, running, hiking, golf, training and all outdoor sports activities.',
    features: ['Impact Resistant', 'Anti-Slip Design', 'Wraparound Style', 'Ventilation System'],
    inStock: true
  },
  {
    id: 'elitestyle-premium-frames',
    name: 'EliteStyle Premium Frames',
    slug: 'elitestyle-premium-frames',
    sku: 'CLC-DF-001',
    price: 99.99,
    image: categoryImages.designer,
    badge: 'New',
    categoryId: 'designer-frames',
    categorySlug: 'designer-frames',
    description: 'Elegant designer frames combining modern aesthetics with premium materials for a high-end look. Hand-finished with refined detailing, the EliteStyle delivers an elevated silhouette that pairs effortlessly with formal looks, daily uniforms or statement evenings.',
    keyBenefits: [
      'Hand-finished premium materials',
      'Refined modern silhouette',
      'Elevated everyday luxury'
    ],
    usage: 'Wear as a statement everyday frame, paired with prescription, blue light or non-prescription lenses.',
    features: ['Premium Materials', 'Hand-Finished', 'Designer Silhouette', 'Prescription Compatible'],
    inStock: true
  },
  {
    id: 'snapshade-clip-on-lenses',
    name: 'SnapShade Clip-On Lenses',
    slug: 'snapshade-clip-on-lenses',
    sku: 'CLC-CL-001',
    price: 24.99,
    image: categoryImages.clipOn,
    categoryId: 'clip-on-lenses',
    categorySlug: 'clip-on-lenses',
    description: 'Easy-to-attach clip-on lenses that convert regular glasses into sunglasses with instant glare protection. Lightweight, magnetic-inspired clips fit a wide range of frames \u2014 just snap on for sun, snap off indoors. The smartest way to add UV protection to your daily eyewear.',
    keyBenefits: [
      'Snap-on UV protection',
      'Fits most standard frames',
      'Lightweight glare reduction'
    ],
    usage: 'Clip onto your prescription or everyday glasses to instantly convert them into sunglasses outdoors.',
    features: ['Universal Clip Fit', 'UV400 Protection', 'Anti-Glare Lens', 'Lightweight'],
    inStock: true
  },
  {
    id: 'proclean-lens-care-kit',
    name: 'ProClean Lens Care Kit',
    slug: 'proclean-lens-care-kit',
    sku: 'CLC-AC-001',
    price: 14.99,
    image: categoryImages.accessories,
    categoryId: 'accessories',
    categorySlug: 'accessories',
    description: 'Complete cleaning kit including microfiber cloth and solution to keep lenses clear and scratch-free. The ProClean kit is the gentle, daily ritual that keeps every pair of eyewear looking and performing like new \u2014 streak-free, residue-free, scratch-safe.',
    keyBenefits: [
      'Streak-free lens cleaning',
      'Safe for all coatings',
      'Compact travel-ready kit'
    ],
    usage: 'Spray a small amount of solution on each lens and gently wipe with the included microfiber cloth daily.',
    features: ['Microfiber Cloth', 'Lens Solution', 'Coating-Safe', 'Travel Size'],
    inStock: true
  },
  {
    id: 'titan-elite-titanium-frames',
    name: 'Titan Elite Titanium Frames',
    slug: 'titan-elite-titanium-frames',
    sku: 'CLC-DF-002',
    price: 249.99,
    image: productImages.titanElite,
    badge: 'Premium',
    categoryId: 'designer-frames',
    categorySlug: 'designer-frames',
    description: 'Precision-engineered from aerospace-grade titanium, the Titan Elite delivers an ultra-light, virtually unbreakable frame with a refined metallic silhouette. Adjustable titanium nose pads, memory-flex hinges and a brushed satin finish make this our most advanced everyday luxury frame \u2014 built to last for years of daily wear.',
    keyBenefits: [
      'Aerospace-grade titanium construction',
      'Virtually unbreakable, featherlight feel',
      'Memory-flex hinges for perfect fit'
    ],
    usage: 'A refined daily frame for professionals and travelers \u2014 pair with prescription, progressive, or premium blue light lenses.',
    features: ['Titanium Frame', 'Memory-Flex Hinges', 'Adjustable Nose Pads', 'Prescription Compatible', 'Lifetime Hinges'],
    inStock: true
  },
  {
    id: 'heritage-gold-signature-frames',
    name: 'Heritage Gold Signature Frames',
    slug: 'heritage-gold-signature-frames',
    sku: 'CLC-DF-003',
    price: 449.99,
    image: productImages.heritageGold,
    badge: 'Luxury',
    categoryId: 'designer-frames',
    categorySlug: 'designer-frames',
    description: 'A signature piece crafted in polished gold-tone metalwork with hand-finished chain detailing and premium Italian acetate temples. The Heritage Gold is a limited-edition silhouette for collectors and connoisseurs \u2014 an heirloom frame that elevates every look it pairs with.',
    keyBenefits: [
      'Limited-edition signature silhouette',
      'Hand-finished gold-tone metalwork',
      'Italian acetate temples with chain detail'
    ],
    usage: 'A statement luxury frame for evening looks, formal occasions, and signature everyday wear. Prescription compatible.',
    features: ['Gold-Tone Hardware', 'Italian Acetate', 'Hand-Finished', 'Limited Edition', 'Luxury Case Included', 'Prescription Compatible'],
    inStock: true
  },
  {
    id: 'platinum-signature-sunglasses',
    name: 'Platinum Signature Edition Sunglasses',
    slug: 'platinum-signature-sunglasses',
    sku: 'CLC-DF-004',
    price: 399.99,
    image: productImages.platinumSignature,
    badge: 'Exclusive',
    categoryId: 'designer-frames',
    categorySlug: 'designer-frames',
    description: 'A designer sunglass flagship \u2014 Platinum-finish metal temples, hand-polished acetate front, and premium polarized lenses with mirror gradient. Delivered in a hand-stitched leather luxury case with cleaning kit, cloth and microfiber sleeve. Designed for those who know the difference.',
    keyBenefits: [
      'Platinum-finish metal temples',
      'Premium polarized mirror-gradient lenses',
      'Hand-stitched leather luxury case'
    ],
    usage: 'Elevated sunwear for driving, travel, beach days and statement daily wear. UV400 certified.',
    features: ['Polarized Mirror Lenses', 'UV400 Protection', 'Platinum Hardware', 'Leather Luxury Case', 'Cleaning Kit Included'],
    inStock: true
  },
  {
    id: 'executive-blue-light-office-bundle',
    name: 'Executive Blue Light Office Bundle \u2014 5 Pairs',
    slug: 'executive-blue-light-office-bundle',
    sku: 'CLC-PC-001',
    price: 179.99,
    image: productImages.executiveBundle,
    badge: 'Bundle',
    categoryId: 'premium-collections',
    categorySlug: 'premium-collections',
    description: 'A five-pair executive set designed for the modern office, home workstation and conference room. Five coordinated blue light blocking frames \u2014 one for the desk, one for the bag, one for home, one for travel and a spare for guests or the team. The smarter way to equip a professional household.',
    keyBenefits: [
      '5 pairs of blue light blocking frames',
      'Perfect for office, home & travel kits',
      'Save vs. buying individually'
    ],
    usage: 'Keep a pair at every workstation \u2014 home office, main office, conference room, travel bag, and spare. Ideal for executive gifting and team outfitting.',
    features: ['5-Pair Bundle', 'Anti-Blue Light Lenses', 'UV400 Protection', 'Mixed Frame Styles', 'Includes 5 Microfiber Pouches'],
    inStock: true
  },
  {
    id: 'clarity-family-set-4-pairs',
    name: 'Clarity Family Set \u2014 4 Pairs',
    slug: 'clarity-family-set-4-pairs',
    sku: 'CLC-PC-002',
    price: 249.99,
    image: productImages.familySet,
    badge: 'Family Pack',
    categoryId: 'premium-collections',
    categorySlug: 'premium-collections',
    description: 'A curated four-pair family bundle featuring a mix of sunglasses, blue light, reading and everyday frames \u2014 something for each member of the household. Delivered in a coordinated carry case with individual microfiber pouches. A beautiful gift set and a smart household investment.',
    keyBenefits: [
      '4 coordinated frames for the whole family',
      'Mixed styles: sun, blue light, reading, everyday',
      'Thoughtful gifting & household value'
    ],
    usage: 'Outfit the whole family \u2014 one pair each for parents, teens, and grandparents. Ideal as a holiday or housewarming gift.',
    features: ['4-Pair Bundle', 'Mixed Lens Types', 'Coordinated Carry Case', 'Individual Microfiber Pouches', 'Gift Ready Packaging'],
    inStock: true
  },
  {
    id: 'complete-vision-wardrobe-8-piece',
    name: 'The Complete Vision Wardrobe \u2014 8-Piece Luxury Set',
    slug: 'complete-vision-wardrobe-8-piece',
    sku: 'CLC-PC-003',
    price: 599.99,
    image: productImages.wardrobeSet,
    badge: 'Signature Set',
    categoryId: 'premium-collections',
    categorySlug: 'premium-collections',
    description: 'The ultimate eyewear wardrobe \u2014 eight curated pieces covering every moment of the day. Includes a designer everyday frame, polarized sunglasses, premium blue light glasses, reading frames, sport performance eyewear, clip-on lenses, a luxury display case and the ProClean care kit. Our flagship all-in-one collection for the eyewear connoisseur.',
    keyBenefits: [
      '8-piece flagship eyewear collection',
      'Covers every style, moment & occasion',
      'Luxury display case & care kit included'
    ],
    usage: 'For the collector, the gift-giver, or anyone who wants their complete eyewear wardrobe in one curated set. Arrives in a signature luxury display case.',
    features: ['8-Piece Set', 'Designer Everyday Frame', 'Polarized Sunglasses', 'Blue Light Glasses', 'Reading Frames', 'Sport Performance', 'Clip-On Lenses', 'Luxury Display Case', 'ProClean Care Kit'],
    inStock: true
  },
  {
    id: 'corporate-team-outfitting-pack',
    name: 'Corporate Team Outfitting Pack \u2014 10 Pairs',
    slug: 'corporate-team-outfitting-pack',
    sku: 'CLC-PC-004',
    price: 349.99,
    image: productImages.executiveBundle,
    badge: 'Team Pack',
    categoryId: 'premium-collections',
    categorySlug: 'premium-collections',
    description: 'Ten coordinated blue light blocking frames for team outfitting, corporate gifting, and workplace wellness programs. Equip an entire department, creative team or client-gifting initiative with premium blue light protection at a bulk-friendly rate. Arrives in a shared presentation case with 10 individual microfiber pouches.',
    keyBenefits: [
      '10 pairs for teams & corporate gifting',
      'Workplace wellness & productivity program ready',
      'Bulk-friendly pricing vs. individual purchase'
    ],
    usage: 'Ideal for corporate team outfitting, workplace wellness initiatives, client gifting, and small-business bulk orders.',
    features: ['10-Pair Bundle', 'Anti-Blue Light Lenses', 'UV400 Protection', 'Presentation Case', '10 Microfiber Pouches', 'Corporate Gifting Ready'],
    inStock: true
  }
];

// ============================================
// FEATURES / WHY CHOOSE US
// ============================================
export const features = [
  { id: 1, title: 'Clear Vision', description: 'Precision optics engineered for everyday clarity' },
  { id: 2, title: 'Daily Comfort', description: 'Lightweight frames designed for all-day wear' },
  { id: 3, title: 'Lightweight Design', description: 'Barely-there feel with durable construction' },
  { id: 4, title: 'Eye Protection', description: 'Blue light, UV & glare defense on every pair' }
];

// ============================================
// STEPS (How it works)
// ============================================
export const steps = [
  { id: 1, title: 'Browse Styles', description: 'Explore our curated collection of premium eyewear.' },
  { id: 2, title: 'Find Your Fit', description: 'Select the perfect frames that match your style.' },
  { id: 3, title: 'Secure Checkout', description: 'Complete your purchase through our safe checkout.' },
  { id: 4, title: 'See Clearly', description: 'Receive your eyewear fast and see the world in style.' }
];
